import React from 'react';
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'

export default function CampaignChecks({ goodStuff = [], warnings = [], showErrors = false, errors = [] }) {
    if (!goodStuff.length && !errors.length) {
        return null;
    }

    return <Paper className="campaign-checks">
        <div className="title">Checks</div>
        {goodStuff.map((error, index) => {
            var classes = 'addCampaign-checksholder'
            return (
                <div key={'checkOk_' + index} className={classes}>
                    <Icons icon='tickCircle' />
                    <div>{error.value}</div>
                </div>
            )
        })}
        {errors.length > 0 && showErrors && errors.map((error, index) => {
            var classes = 'addCampaign-checksholder addCampaign-checksholder-bad'
            return (
                <div key={'checkErr_' + index} className={classes}>
                    <Icons icon='crossCircle' />
                    <div>{error.value}</div>
                </div>
            )
        })
        }

        {warnings.length > 0 && warnings.map((warning, index) => {
            var classes = 'addCampaign-checksholder addCampaign-checksholder-warn'
            return (
                <div key={'checkWarn_' + index} className={classes}>
                    <Icons icon='alert' />
                    <div>{warning.value}</div>
                </div>
            )
        })}

    </Paper>
}